// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { SidebarNextGen as default } from './ui';
